var FileUtils = /** @class */ (function () {
    function FileUtils() {
    }
    FileUtils.getFileExtension = function (filename) {
        var ext = /^.+\.([^.]+)$/.exec(filename);
        return ext == null ? "" : ext[1];
    };
    FileUtils.getFileIcon = function (filename) {
        if (FileUtils.textExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_text";
        }
        else if (FileUtils.videoExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_play";
        }
        else if (FileUtils.photoExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_image";
        }
        else if (FileUtils.soundExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_sound";
        }
        else if (FileUtils.webExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_web";
        }
        else if (FileUtils.wordExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_word";
        }
        else if (FileUtils.spreadsheetExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_spreadsheet";
        }
        else if (FileUtils.presentationExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_presentation";
        }
        else if (FileUtils.compressedExtensions.indexOf(FileUtils.getFileExtension(filename)) > -1) {
            return "odi_compressed";
        }
        else {
            return "odi_file";
        }
    };
    FileUtils.isImage = function (data) {
        var pattern = new RegExp("^image/?");
        return pattern.test(data);
    };
    FileUtils.textExtensions = ["txt", "text", "readme", "lst", "me", "rft", "rtx", "rtf", "textclipping", "dsc", "wtx",
        "uof", "wn", "faq", "notes", "log", "err", "klg", "asc", "ascii", "utxt", "utf8", "xdl",
        "xwp", "tex", "sty"];
    FileUtils.videoExtensions = ["asf", "asx", "avi", "flv", "m4v", "mov", "mp4", "mpg", "rm", "srt", "swf", "vob", "wmv",
        "aepx", "ale", "avp", "avs", "bdm", "bik", "bin", "bsf", "camproj", "cpi", "dat", "divx",
        "dmsm", "dream", "dvdmedia", "dvr-ms", "dzm", "dzp", "edl", "f4v", "fbr", "fcproject",
        "hdmov", "imovieproj", "ism", "ismv", "m2p", "mkv", "mod", "moi", "mpeg", "mts", "mxf",
        "ogv", "otrkey", "pds", "prproj", "psh", "r3d", "rcproject", "rmvb", "scm", "smil", "sqz",
        "stx", "swi", "tix", "trp", "ts", "veg", "vf", "vro", "webm", "wlmp", "wtv", "xvid", "yuv"];
    FileUtils.photoExtensions = ["bmp", "dds", "gif", "jpg", "png", "psd", "pspimage", "tga", "thm", "tif", "tiff", "yuv",
        "abm", "afx", "cpg", "cpt", "dcm", "dib", "dpx", "dt2", "hdp", "ipx", "itc2", "jp2", "jpeg",
        "jps", "jpx", "max", "mng", "mpo", "mxi", "pictclipping", "ppm", "psp", "pspbrush", "pvr",
        "pxm", "sdr", "sid", "skm", "thm", "tif", "wb1", "wbc", "wbd", "wbz", "xcf"];
    FileUtils.soundExtensions = ["aif", "iff", "m3u", "m4a", "mid", "mp3", "mpa", "ra", "wav", "wma", "aa", "aa3", "acd",
        "acd-zip", "acm", "afc", "als", "amr", "amxd", "amz", "ape", "at3", "caf", "cda", "cpr",
        "dcf", "dmsa", "dmse", "dss", "emp", "emx", "flac", "gpx", "logic", "m3u8", "m4b", "m4r",
        "midi", "mod", "mxl", "nki", "nra", "ogg", "omf", "pcast", "pls", "ptf", "ptx", "ram",
        "rns", "rx2", "seq", "sesx", "sib", "slp", "snd", "trak"];
    FileUtils.webExtensions = ["asp", "aspx", "cer", "cfm", "csr", "css", "htm", "html", "js", "jsp", "php", "rss",
        "xhtml", "a5w", "alx", "asax", "asmx", "atom", "att", "axd", "chm", "crt", "cshtml", "dwt",
        "fcgi", "htaccess", "jnlp", "json", "jspx", "nzb", "opml", "p12", "pac", "qbo", "spc",
        "ucf", "webarchive", "wgt", "wml", "wsdl", "xfdl", "xhtm", "a4p", "adr", "aex", "an", "ap",
        "aro", "asa", "ascx", "ashx", "asr", "awm", "bml", "bok", "browser", "btapp", "cha", "chat",
        "codasite", "con", "crl", "dap", "dcr", "der", "dhtml", "disco", "discomap", "dll", "do",
        "attachmentDownload", "edge", "epibrw", "esproj", "ewp", "fwp", "gne", "gsp", "htx", "hxs", "hype",
        "idc", "iwdgt", "jhtml", "jws", "lasso", "lbc", "less", "maff", "mht", "mhtml", "mspx",
        "muse", "mvc", "oam", "obml", "ognc", "oth", "p7b", "p7c", "pem", "pro", "psp", "pub", "qf",
        "rhtml", "rjs", "rt", "rwp", "rwsw", "saveddeck", "shtm", "shtml", "sitemap", "sites2",
        "srf", "stc", "suck", "swz", "tvpi", "tvvi", "url", "vbd", "vbhtml", "vdw", "vrml",
        "vsdisco", "wdgt", "web", "webbookmark", "webhistory", "webloc", "website", "whtt", "woa",
        "wpp", "wrf", "xbel", "xht", "xpd", "xul", "zfo", "zhtml", "zhtml", "zul", "zvz"];
    FileUtils.wordExtensions = ["gdoc", "doc", "docx", "docxml", "lwp", "mwp", "mcw", "mw", "aww", "awp", "abw", "awt",
        "ott", "fodt", "odt", "fwdn", "sxw", "sdw", "wps", "wpt", "mwd", "mellel", "mell", "wp6",
        "wp7", "wpd", "wp", "wpt", "wbk", "wsd", "xy", "xyw", "xy3", "xyp", "njx", "lyx", "hwp"];
    FileUtils.spreadsheetExtensions = ["xlr", "xls", "xlsx", "gsheet", "nb", "numbers", "ods", "qpw", "wks", "xlsb", "xltm",
        "xltx", "aws", "fods", "numbers-tef", "ots", "pmd", "rdf", "sdc", "sxc", "uos", "xlsm"];
    FileUtils.presentationExtensions = ["key", "pps", "ppt", "pptx", "ppsx", "pptm", "pot", "potm", "potx", "pptm", "ppsm",
        "gslides", "odp", "dps", "fodp", "key-tef", "kpp", "kpr", "otp", "pez", "prd", "prs",
        "show", "shw", "sxi", "uop", "wnk", "apxl", "dpt", "prt", "prv", "prz", "sdd", "sdp", "sti",
        "prc"];
    FileUtils.compressedExtensions = ["cbr", "deb", "gz", "pkg", "rar", "rpm", "sitx", "zip", "zipx", "alz", "bz", "bz2", "cbz",
        "mpkg", "pet", "sfx", "sit", "tgz", "war", "ace", "apz", "ar", "arc", "b1", "b64", "ba",
        "bzip", "c00", "c01", "cba", "cbt", "cp9", "cpgz", "czip", "dar", "dgc", "dist", "dl_",
        "ecs", "efw", "egg", "f", "gca", "gzip", "hbc", "hki", "hki1", "hki2", "hki3", "ice", "ipg",
        "ipk", "ita", "jgz", "jic", "kgb", "lbr", "lha", "lnx", "lqr", "lz", "lzm", "lzma", "lzo",
        "mint", "mzp", "mzp", "package", "pae", "pak", "paq6", "paq7", "par", "par2", "pbi", "pea",
        "pf", "piz", "psz", "pup", "pwa", "qda", "r00", "r01", "rp9", "rte", "rz", "s00", "s01",
        "s02", "s7z", "sar", "sdc", "sea", "sfs", "sh", "shr", "sqx", "taz", "tbz", "tz", "uha",
        "vem", "vsi", "xef", "xmcdz", "z", "z01", "zfsendtotarget", "zz"];
    return FileUtils;
}());
export { FileUtils };
//# sourceMappingURL=file-utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-utils/file-utils.js
// module id = 428
// module chunks = 14